module.exports = __webpack_public_path__ + "img/ai-icon.0cef76a1.png";